module.exports = __webpack_public_path__ + "img/Mister_Bit.547aacb2.svg";